module.exports = __webpack_public_path__ + "static/img/6.7a1311f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/zh/6.png
// module id = mIX3
// module chunks = 0